module.exports = __webpack_public_path__ + "static/wfp-logo-vertical-black-en-56c796e4ddcda65e22bdb0596e8d0ee5.svg";